import { Button, Card, Grid } from "@mui/material";
import { useState } from "react";
import { theme } from "utils/Theme";
import Admins from "./Admins";
import ClientsTable from "./ClientsTable";
import PartnerTable from "./PartnerTable";

const UserDetails = () => {
  const profileButtons = ["Admins", "Client", "Partner"];
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 1,
          }}
        >
          <Grid container spacing={1}>
            {profileButtons.map((label, index) => (
              <Grid item key={label}>
                <Button
                  variant={activeTab === index ? "contained" : "outlined"}
                  onClick={() => setActiveTab(index)}
                  sx={{
                    minWidth: 100,
                    padding: "5px 10px",
                    background: `${theme.palette.primary}11`,
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                >
                  {label}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 3 }}>
        {activeTab === 0 && <Admins />}
        {activeTab === 1 && <ClientsTable />}
        {activeTab === 2 && <PartnerTable />}
      </Grid>
    </Grid>
  );
};

export default UserDetails;
